export const formatDateLocal = (date) => {
      if (!date) return '';
      const parsedDate = new Date(date);
      if (Number.isNaN(parsedDate.getTime())) return '';

      return `${parsedDate.toLocaleString(undefined, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          })}`;
    };

export const formatTimeZone = () => {
      return `Time shown in your local time zone: ${Intl.DateTimeFormat().resolvedOptions().timeZone}` || '';
    };
